module.exports = __webpack_public_path__ + "img/car_0002.11aaf0a4.jpg";